import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./DetailGrid.module.scss";
import Detail, { DetailProps } from "../Detail/Detail";

export interface DetailGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  columns?: "responsive" | 1 | 2 | 3;
}

const DefaultDetailGrid = ({ className, children, columns = "responsive", ...props }: DetailGridProps) => (
  <div className={styles.container} data-deci-detail-grid-container="true">
    <div
      className={clsx(styles.grid, className)}
      data-deci-detail-grid="true"
      data-columns={String(columns)}
      {...props}
    >
      {children}
    </div>
  </div>
);

const DetailGrid = createPluggable<DetailGridProps>("deci.detailGrid", DefaultDetailGrid);

export interface DetailGridItemProps extends DetailProps {

}

const DetailGridItem = (props: DetailGridItemProps) => {
  const { className, children, ...otherProps } = props;
  const childArray = React.Children.toArray(children);
  const hasIcon = childArray.some((child) => React.isValidElement(child) && child.type === Detail.Icon);

  return (
    <Detail className={clsx(className, styles.item)} {...otherProps}>
      {!hasIcon ? (
        <Detail.Icon aria-hidden="true" className={styles.iconPlaceholder}>
          <span />
        </Detail.Icon>
      ) : null}
      {children}
    </Detail>
  );
}

export default Object.assign(DetailGrid, {
  Item: DetailGridItem,
  Icon: Detail.Icon,
  Title: Detail.Title,
  Content: Detail.Content,
});
